import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const HandIcon = ({
  width = 48,
  marginLeft,
  marginRight,
  color = 'foraBlue',
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <path id="prefix__a" d="M0.986 0.709L11.432 0.709 11.432 11.154 0.986 11.154z" />
        <path id="prefix__b" d="M0 0.544L44.571 0.544 44.571 39.545 0 39.545z" />
        <path id="prefix__c" d="M0.165 0.729L12.372 0.729 12.372 12.936 0.165 12.936z" />
        <path id="prefix__e" d="M0 0.179L12.303 0.179 12.303 23.739 0 23.739z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(17.5 10) translate(25.91 .655)" />
          <g transform="translate(17.5 10) translate(0 19.746)" />
        </g>
        <g>
          <g transform="translate(5.085 12.5) translate(38.194 .931)">
            <path
              fill={getSemanticTextColor(color)}
              d="M12.372 6.832c0 3.37-2.733 6.104-6.104 6.104-3.368 0-6.103-2.733-6.103-6.104C.165 3.462 2.9.729 6.268.729c3.37 0 6.104 2.733 6.104 6.103"
            />
          </g>
          <path
            fill={getSemanticTextColor(color)}
            d="M40.103 22.875c0 3.37-2.732 6.103-6.103 6.103-3.37 0-6.103-2.733-6.103-6.103 0-3.37 2.734-6.102 6.103-6.102 3.371 0 6.103 2.731 6.103 6.102"
            transform="translate(5.085 12.5)"
          />
          <path
            fill={getSemanticTextColor(color)}
            d="M34.356 48.986c-2.088.317-4.195.477-6.307.477l-15.056-.606L6.818 32.18s10.2-8.542 19.525-4.992c2.245.854 4.291 2.16 6.694 2.16h4.122c2.67 0 5.232 1.26 6.717 3.478.936 1.393.32 1.98-.244 2.57l-8.488-.385-5.75-.173c-3.308 0-6.28 3.644-6.28 6.29 0 0 2.776-4.951 7.43-5.139l4.655.095 4.678.217c2.901-.038 11.782-.023 12.828-.58l9.169-5.604c4.603-2.42 5.7-1.982 7.026-.137.619.863.451 2.067-.366 2.745L52.471 45.233c-.814.78-1.831 1.345-2.947 1.503l-.022.002c-.443.098-.898.154-1.368.154l-12.935 1.965-.843.13z"
            transform="translate(5.085 12.5)"
          />
          <g transform="translate(5.085 12.5) translate(0 30.332)">
            <path
              fill={getSemanticTextColor(color)}
              d="M1.867.388C3.233-.121 4.665.333 5.058 1.396l7.144 19.293c.392 1.06-.398 2.336-1.767 2.843-1.368.506-2.796.054-3.193-1.01L.102 3.232C-.295 2.166.496.896 1.866.388"
            />
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
